import src from "IMAGE";
export default { src, width: 841, height: 790, blurWidth: 0, blurHeight: 0};
